'use client';

import { c as _c } from "react/compiler-runtime";
import { ScrollArea } from '@ncai-axe/react-ui-v3';
import IcErrorBlue from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_error_blue.svg';
import { useTranslations } from 'next-intl';
import styles from './styles.module.scss';
interface ErrorPageProps {
  title: string;
  description: string[];
  onClickHome: () => void;
}
export default function ErrorPage(t0) {
  const $ = _c(16);
  const {
    title,
    description,
    onClickHome
  } = t0;
  const t = useTranslations("common");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcErrorBlue className={styles.icon} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h2 className={styles.title}>{title}</h2>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = description.map(_temp);
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className={styles.description}>{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("actions.goHome");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClickHome || $[10] !== t5) {
    t6 = <button className={styles.homeButton} onClick={onClickHome}>{t5}</button>;
    $[9] = onClickHome;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = <ScrollArea type="hover" className={styles.scrollArea}><div className={styles.container}><div className={styles.content}>{t1}{t2}{t4}{t6}</div></div></ScrollArea>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(line, i) {
  return <p key={i}>{line}</p>;
}